import Onboard from '../../api/onboard';

export const actions = {
  async createOnboard(_context, body) {
    const response = await Onboard.create(body);
    return response.data;
  },
};

export default {
  actions,
};
